export default "https://assets.pclncdn.com/web/next-landing/6889411/_next/static/images/vegas-91e4b3cad3886260a233bd4bc5a20692.webp";